module.exports = __webpack_public_path__ + "img/unkonw.f3fe6cea.png";